import React, { Component } from 'react';
import { Creatable } from 'react-select';
import Select from './ui/Select';
import Constants from './../constants';
import Clipboard from 'clipboard';
import PropTypes from 'prop-types';

class RightSide extends Component {
	constructor(props) {
		super(props);
		this.state = {
			appName: null,
			appId: null,
			appUrl: null,
			appEmail: null,
			appType: null,
			appGUID: {},
			appOrganization: {},
			appAccount: null,
			guidArr: [],
			organization: {},
			successOrNot: null
		};
		this.handleInputChange = this.handleInputChange.bind(this);
		this.getAppGUIDs = this.getAppGUIDs.bind(this);
		this.getAccounts = this.getAccounts.bind(this);
	};
	getNullInputValues() {
		this.refs['appNameId'].value = null;
		this.refs['appIdId'].value = null;
		this.refs['appUrlId'].value = null;
		this.refs['appEmailId'].value = null;
	};
	componentWillReceiveProps(nextProps) {
		if(nextProps.createNewApp) {
			this.setState({
				id: null,
				appName: null,
				appId: null,
				appUrl: null,
				appEmail: null,
				appType: null,
				appGUID: null,
				appOrganization: this.props.app.organization,
				appAccount: null,
				successOrNot: null
			});
			this.getNullInputValues();
			this.props.falseNewApp();
		}
		if((nextProps.app.id !== this.props.app.id) || (!nextProps.createNewApp !== this.props.createNewApp)) {
			this.setState({
				id: nextProps.app.id,
				appName: nextProps.app.description,
				appId: nextProps.app.name,
				appUrl: nextProps.app.url,
				appEmail: nextProps.app.notify_email,
				appType: nextProps.app.type,
				appGUID: nextProps.app.profile,
				appOrganization: nextProps.app.organization,
				appAccount: nextProps.app.account,
				successOrNot: null
			});
			this.getNullInputValues();
		}
	};
	componentDidUpdate(prevProps, prevState) {
		if(prevState.appOrganization !== this.state.appOrganization || prevProps.app.id !== this.props.app.id) {
			this.onOrganizationChange();
			this.getAppGUIDs();
			this.getAccounts();
		}
	};
	componentWillMount() {
		this.clipboard = new Clipboard('#copyGuid', {
			text: function(e) {
				let text = e.previousSibling.textContent;
				let copied = text.slice(4, -1);
				return copied;
			}
		});
		this.clipboard.on('success', function(e) {
			e.trigger.innerHTML = 'Copied';
			e.trigger.style.backgroundColor = "#61b73c";
			window.setTimeout(() => {
				e.trigger.innerHTML = 'Copy';
				e.trigger.style.backgroundColor = "#2bd1f2";
			}, 1200);
			e.clearSelection();
		});
		this.clipboard.on('error', function(e) {
			e.trigger.innerHTML = 'Not copied';
			e.trigger.style.backgroundColor = "#f96351";
			console.error('Action:', e.action);
			console.error('Trigger:', e.trigger);
		});
	};
	componentWillUnmount() {
		if(this.clipboard) {
			this.clipboard.destroy();
		}
	};
	handleInputChange(event) {
		if(event) {
			const target = event.target;
			const value = target.value;
			const name = target.name;

			this.setState({
				[name]: value
			});
		}
	};
	handleFocus(event) {
		event.target.select();
	};
	getAppTypes() {
		return fetch(Constants.SERVER_PATH + `app_type`)
			.then((resp) => {
				return resp.json();
			})
			.then((json) => {
				return {options: json.result};
			})
			.catch((error) => {
				console.log('app_type ' + error);
			});
	};
	getAccounts() {
		return fetch(Constants.SERVER_PATH + `account`)
			.then((resp) => {
				return resp.json();
			})
			.then((json) => {
				return {options: json.result};
			})
			.catch((error) => {
				console.info('getAccounts Error: ' + error);
			});
	};
	getAppGUIDs() {
		if((this.state.appOrganization) > 0) {
			return fetch(Constants.SERVER_PATH + `profile?org=${this.state.appOrganization.id || this.state.appOrganization}`)
				.then(resp => {
					return resp.json();
				})
				.then(json => {
					this.setState({guidArr: json.result});
					return {options: json.result};
				})
				.catch(error => {
					console.log('profile?org ' + error);
				});
		}
	}
	hideNotification() {
		window.setTimeout(() => {
			this.setState({successOrNot: ''});
		}, 5000);
	}
	chooseWayToSave(respData) {
		if(this.state.id) {
			return fetch(Constants.SERVER_PATH + `app/${this.state.id}`, {
				method: 'PUT',
				body: JSON.stringify(respData)
			}).then(e => {
				if(e.status > 400) {
					this.setState({successOrNot: 'Приложение не изменено, вероятно, потому что оно удалено (или что-то ещё): ' + e.statusText});
					this.hideNotification();
				} else {
					this.setState({successOrNot: 'Приложение изменено успешно'});
					this.hideNotification();
				}
			}).catch((error) => {
				this.setState({successOrNot: 'Приложение не изменено, чё-то не так: ' + error});
				this.hideNotification();
			});
		} else {
			return fetch(Constants.SERVER_PATH + `app`, {
				method: 'POST',
				body: JSON.stringify(respData)
			}).then((resp) => {
				return resp.json();
			}).then((json) => {
				this.setState({successOrNot: 'Приложение создано успешно'});
				this.hideNotification();
			}).catch((error) => {
				console.log('app POST ' + error);
				this.setState({successOrNot: 'Приложение не создано, чё-то не так: ' + error});
				this.hideNotification();
			});
		}
	}
	saveApp() {
		let data = {
			id: this.state.id ? this.state.id : null,
			name: this.state.appId,
			type: this.state.appType.id ? this.state.appType.id : this.state.appType,
			account: (this.state.appAccount && this.state.appAccount.id) ?
				this.state.appAccount.id : this.state.appAccount,
			profile: (this.state.appGUID && this.state.appGUID.id) ?
				this.state.appGUID.id : (this.state.appGUID || null),
			description: this.state.appName,
			url: this.state.appUrl,
			organization: (this.state.appOrganization && this.state.appOrganization.id) ?
				this.state.appOrganization.id : this.state.appOrganization > 0 ?
					this.state.appOrganization : null,
			notify_email: this.state.appEmail
		};
		if(this.state.appGUID && typeof(this.state.appGUID.id) === 'string') {
			return fetch(Constants.SERVER_PATH + `profile`, {
				method: 'POST',
				body: JSON.stringify({
					id: this.state.id ? this.state.id : null,
					guid: this.state.appGUID.guid,
					organization: this.state.appOrganization.id ?
						this.state.appOrganization.id : this.state.appOrganization
				})
			}).then((resp) => {
				return resp.json();
			}).then((json) => {
				data.profile = json.result.id;
				this.chooseWayToSave(data);
				this.setState({successOrNot: 'Профиль успешно создан'});
				this.hideNotification();
			}).catch((error) => {
				console.log('profile POST ' + error);
				this.setState({successOrNot: 'Профиль не создан, чё-то не так: ' + error});
				this.hideNotification();
			})
		} else {
			this.chooseWayToSave(data);
		}
	};
	removeApp() {
		return fetch(Constants.SERVER_PATH + `app/${this.state.id}`, {
			method: 'DELETE'
		}).then(() => {
			this.setState({successOrNot: 'Приложение успешно удалено'});
			this.hideNotification();
		}).catch((error) => {
			this.setState({successOrNot: 'Приложение не удалено, чё-то не так: ' + error});
			this.hideNotification();
		});
	}
	onAppTypeChange = (selected) => {
		this.setState({appType: selected});
	};
	onAccountChange = (selected) => {
		this.setState({appAccount: selected})
	};
	onAppGUIDChange = (selected) => {
		this.setState({appGUID: selected})
	};
	onOrganizationChange = (selected) => {
		if(!selected) {
			this.setState({organization: this.state.appOrganization});
		} else {
			this.setState({appOrganization: selected.id})
		}
	};
	render() {
		return (
			<div className="right-column">
				<div className="row row-indent">
					<label>Имя</label>
					<input
						ref="appNameId"
						name="appName"
						type="text"
						value={this.state.appName ? this.state.appName : null}
						onFocus={this.handleFocus}
						onChange={this.handleInputChange} />
				</div>
				<div className="row row-indent">
					<label>Тип приложения</label>
					<Select.Async
						value={this.state.appType}
						labelKey="name" valueKey="id"
						onChange={this.onAppTypeChange}
						loadOptions={this.getAppTypes}
						/>
				</div>
				<div className="row row-indent">
					<label>APPID</label>
					<input
						ref="appIdId"
						name="appId"
						type="text"
						value={this.state.appId ? this.state.appId : null}
						onFocus={this.handleFocus}
						onChange={this.handleInputChange} />
				</div>
				<div className="row row-indent">
					<label>URL</label>
					<input
						ref="appUrlId"
						name="appUrl"
						type="text"
						value={this.state.appUrl ? this.state.appUrl : null}
						onFocus={this.handleFocus}
						onChange={this.handleInputChange} />
				</div>
				<div className="row-indent row-bottom-2 columns align-end">
					<div className="full-width">
						<label>GUID</label>
						<Creatable
							value={this.state.appGUID}
							labelKey="guid" valueKey="id"
							onChange={this.onAppGUIDChange}
							options={this.state.guidArr}
							placeholder={'Результатов: ' + this.state.guidArr.length}
						/>
					</div>
					<button className="normal ml1 b-height" id="copyGuid" disabled={!this.state.appGUID}>copy</button>
				</div>
				<div className="row row-indent row-bottom-2">
					<label>Организация</label>
					<Select
						value={this.state.appOrganization ? this.state.appOrganization : null}
					    labelKey="name" valueKey="id"
					    onChange={this.onOrganizationChange}
					    options={this.props.orgs}
						/>
				</div>

				<div className="row row-indent row-bottom-2">
					<label>Учётная запись</label>
					<Select.Async
						value={this.state.appAccount}
						labelKey="name" valueKey="id"
						onChange={this.onAccountChange}
						loadOptions={this.getAccounts}
					/>
				</div>

				<div className="row row-indent row-bottom-2">
					<label>EMAIL для уведомления</label>
					<input
						ref="appEmailId"
						name="appEmail"
						type="text"
						value={this.state.appEmail ? this.state.appEmail : null}
						onFocus={this.handleFocus}
						onChange={this.handleInputChange} />
				</div>
				<div className="columns row-indent">
					<button
						className="remove sm-size b-height"
						disabled={!this.state.id}
						onClick={this.removeApp.bind(this)}>Удалить приложение</button>
					<button
						className="normal sm-size b-height"
						disabled={!(this.state.appId && this.state.appType)}
						onClick={this.saveApp.bind(this)}>Сохранить</button>
				</div>
				<div className="row row-indent ta-c">
					{this.state.successOrNot}
				</div>
			</div>
		);
	};
}

RightSide.propTypes = {
	app: PropTypes.object,
	orgs: PropTypes.array,
	accounts: PropTypes.array,
	saveApp: PropTypes.func,
	createNewApp: PropTypes.bool,
	falseNewApp: PropTypes.func
};

export default RightSide;


// WEBPACK FOOTER //
// ./src/components/right_side.js